<label
    class="toggle toggle--table-edit"
    [class.disabled]="disabled()"
    [matTooltip]="disabledTooltip() ? (disabledTooltip() | transloco) : undefined">
    <input
        type="checkbox"
        [checked]="checked()"
        [disabled]="disabled()"
        (change)="onToggleChange()" />

    <div
        class="slider"
        [class.checked]="checked()"
        [class.disabled]="disabled()"
        [class.unchecked]="!checked()">
        <span class="switch"></span>
    </div>
</label>
